export interface VariablePlagueCulture {
    variableId: string;
    excludingCultureIds?: string[];
    inclusiveCultureIds?: string[];
}